import { defineComponent as _defineComponent } from 'vue'
import BCXChevronSwitch from '@/components/molecules/BCXChevronSwitch.vue';
import NotificationBarItem from '@/components/toolbar/notification/NotificationBarItem.vue';
import useResponsiveness from '@/mixins/useResponsiveness';
import useNotificationState from '@/state/notificationState';
import { computed } from 'vue';
import { NotificationBarPanelItem, NotificationType } from '@/models/Notification';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationBar',
  props: {
  active: {
    type: String,
    default: ''
  },
},
  setup(__props) {



const { isMobileWidth } = useResponsiveness();
const { showPanel, notificationCounts, totalCount } = useNotificationState();

const barItems = computed<NotificationBarPanelItem[]>(() => [
  NotificationType.Projects,
  NotificationType.Talks,
  NotificationType.Messages,
  NotificationType.Contracts,
  NotificationType.Invoices,
  NotificationType.Meetings
].map((notificationType) => ({
  notificationType,
  count: notificationCounts.value?.[notificationType] ?? 0,
})).filter((item) => !!item.count));

const getPosForIndex = (index:number):number => {
  const { length } = Object.keys(barItems.value);
  if (length <= 1) return 0.5;
  return index / (length - 1);
};


return { __sfc: true,isMobileWidth, showPanel, notificationCounts, totalCount, barItems, getPosForIndex, BCXChevronSwitch, NotificationBarItem }
}

})